import React from 'react';
import { connect } from 'dva';
import { templateConfig, reduxTemplateCofig } from './config'

import { framework_tool, utils_tool, component_tool } from '@/tool'
let { WizContainer, WizReduxTemplate } = framework_tool;
let { WizNotice, WizBrowserExport } = component_tool;
let { checkStrLength, toChinesNum } = utils_tool;
class ContentLabel extends WizContainer {
  componentName = 'ContentLabel';

  constructor(props) {
    super(props);
    this.state = {
      type: props['type']
    }
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }
  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '标签名称',
        field: 'title',
        width: 20,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
        },
      },
      {
        headerName: '标签分类',
        field: 'categoryName',
        width: 20,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
        },
      },
      {
        headerName: '顺序',
        field: 'orderNo',
        width: 10,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
        },
      },
      {
        headerName: '标签热度值',
        field: 'hotValue',
        width: 10,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
        },
      },
      {
        headerName: '标签说明',
        field: 'intro',
        width: 30,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
        },
      },
    ]
    if (o['success']) {
      let dataList = Object.assign([], o['data'])
      WizBrowserExport({
        title: '标签信息',
        sheetName: '标签信息',
        columns: columnDefs.filter((_, index) => index),
        rows: dataList,
        filename: '标签信息.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }
  _handleTreeData(nextProps, nextState, key) {
    let o = nextProps[key]
    let len = 20
    if (o['success']) {
      let f = (v) => {
        v && v.forEach(val => {
          val['title'] = checkStrLength(val['title'], len);
          if (val['children'] && val['children'].length > 0) {
            f(val['children'])
          }
        });
      }
      f(o['data'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }
  _render() {
    let { type } = this.props
    let _reduxTemplateCofig = reduxTemplateCofig({
      type,
      templateConfig: templateConfig({ type, pathname: this.props.location.pathname }),
      apiDataFormat: {
        add: this._handleCMD,
        update: this._handleCMD,
        delete: this._handleCMD,
        enable: this._handleCMD,
        treeData: this._handleTreeData,
        export: this._handleFile,
      },
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

const mapStateToProps = (state, ownProps) => {

  const pathList = ownProps.location.pathname.split('/')
  const categoryType = pathList[pathList.length - 2]

  let typeObj = {
    contentLabel:'6',
    homeworkLabel:'12'
  }
  const type = typeObj[categoryType]
  return {type}
};

export default connect(mapStateToProps)(ContentLabel);
